import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';

import Button from '@nexus/fff-ui-shared/Button';
import {
  showSuccessToast,
  showErrorToast,
} from 'shared-components/BaseToast/Toast';
import AdminInput from 'shared-components/AdminInput/AdminInput';

import {
  fetchDefaultCampaign,
  importCampaign,
} from 'services/api/admin-refills';

import styles from './CampaignSection.module.scss';

const SUCCESS_MESSAGE = 'Campaign imported successfully';

const CampaignSection = ({ seasonTitle, isCurrentCampaign }) => {
  const [campaignData, setCampaignData] = useState({});
  const [campaignId, setCampaignId] = useState('');
  const {
    originCampaignId,
    type,
    title,
    description,
    published,
    start,
    stop,
    startPremium,
    stopPremium,
    default: campaignDefault,
  } = campaignData;
  const campaignIdValue = (isCurrentCampaign && originCampaignId) || campaignId;

  const getDefaultCampaign = async () => {
    const campaignRes = await fetchDefaultCampaign();
    setCampaignData(campaignRes);
  };

  const handleCampaignImport = async () => {
    try {
      const response = await importCampaign(campaignId, isCurrentCampaign);
      setCampaignData(response);
      showSuccessToast(SUCCESS_MESSAGE);
    } catch (error) {
      showErrorToast(error.message);
    }
  };

  useEffect(() => {
    if (isCurrentCampaign) {
      getDefaultCampaign();
    }
  }, []);

  return (
    <div className={styles.campaignSeason}>
      <h4>{seasonTitle}</h4>
      <div className={styles.buttonsGroup}>
        <AdminInput
          type="text"
          label="Campaign ID"
          placeholder="Enter customize campaign ID"
          value={campaignIdValue}
          onChange={(e) => setCampaignId(e.target.value)}
        />
        <Button variation="black" onClick={handleCampaignImport}>
          SUBMIT
        </Button>
      </div>
      <div className={styles.campaignDetails}>
        <h5>Current Default Campaign Details</h5>
        <div className={styles.campaignContainer}>
          <div className={styles.campaignDetailsLabels}>
            <p>OriginCampaignId:</p>
            <p>Type:</p>
            <p>Title:</p>
            <p>Description:</p>
            <p>Published:</p>
            <p>Start:</p>
            <p>Stop:</p>
            <p>StartPremium UTC:</p>
            <p>StopPremium UTC:</p>
            <p>Default:</p>
          </div>
          {campaignData && originCampaignId && (
            <div className={styles.campaignDetailsInfo}>
              <p>{originCampaignId}</p>
              <p>{type}</p>
              <p>{title}</p>
              <p>{description}</p>
              <p>{String(published)}</p>
              <p>{start}</p>
              <p>{stop}</p>
              <p>{startPremium}</p>
              <p>{stopPremium}</p>
              <p>{String(campaignDefault)}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

CampaignSection.propTypes = {
  seasonTitle: PropTypes.string.isRequired,
  isCurrentCampaign: PropTypes.string,
};

CampaignSection.defaultProps = {
  isCurrentCampaign: false,
};

export default CampaignSection;
